import React, { PropTypes } from 'react'
import Heading from 'components/Heading'
import Dialog from 'components/Dialog'
import Card from 'components/Card'
import Loading from 'components/Loading'
import Alert from 'components/Alert'
import FileUploader from 'components/FileUploader/FileUploader'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import Button from 'components/Button'
import SubmitButton from 'components/SubmitButton'
import constants from 'constants'
import BeneficiaryUploadList from './components/Beneficiary/BeneficiaryUploadList'
import { agent } from 'utils/api'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'
import classnames from 'classnames'

const styles = Object.assign(
  {},
  require('./Beneficiaries.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class BeneficiaryUploadView extends React.Component {
  static propTypes = {
    completeText: PropTypes.string,
    ctaText: PropTypes.string,
    deleteUpload: PropTypes.object.isRequired,
    initUpload: PropTypes.object.isRequired,
    beneficiaryUpload: PropTypes.object.isRequired,
    lockBeneficiary: PropTypes.func.isRequired,
    sendNotification: PropTypes.object.isRequired,
    submittingText: PropTypes.string,
  }
  static defaultProps = {
    ctaText: 'Upload',
    completeText: 'Uploaded',
    submittingText: 'Uploading',
  }

  constructor() {
    super()

    this.state = {
      showLockDialog: false,
      showUnlockDialog: false,
      showUploadDialog: false,
      currentFy: (getFiscalYearTimestamps().current.year),
      selectedMenuAction: '',
      submittedFiles: [],
      uploader: null,
      isComplete: false,
      isPosting: false,
    }
  }

  componentWillMount() {
    this.setState({ uploader: this.myUploader() })
  }

  setSubmittedFiles = (submittedFiles) => {
    this.setState({ submittedFiles })
  }

  setFileUploaderResponse = (response) => {
  }

  _initForm = () => {
    this.setState({ isPosting: false }, () => {
      this.state.uploader.methods.reset()
      this.setState({ isComplete: true })
      this.setState({ submittedFiles: [] })
      setTimeout(() => {
        this.props.initUpload()
        this.setState({ isComplete: false })
      }, 2000)
    })
  }

  _handleSubmit = () => {
    if (this.state.submittedFiles.length > 0) {
      this.setState({ isPosting: true }, () => {
        this.state.uploader.methods.uploadStoredFiles()
      })
    }
  }

  _handleAllUploadComplete = (id, name, response) => {
    if (response.success) {
      // this._initForm()
    } else {
      this.props.sendNotification(response.error)
    }
  }

  _handleUploadComplete = (id, name, response) => {
    if (response.success || response.error) {
      this.props.sendNotification(response.error)
    }
    this._initForm()
  }

  _handleUploadError = (id, name, response) => {
    this.props.sendNotification((response.error ? response.error : response))
    this._initForm()
  }

  // Moving logic from Uploader ...
  myUploader = () => {
    // const { allowedExtensions, uploadID, maxFileSize } = this.props
    const allowedExtensions = ['csv']
    // const uploadID = '1234'
    const maxFileSize = constants.BENEFICIARY.UPLOAD_MAX_FILESIZE
    const maxFileNumber = 1

    return new FineUploaderTraditional({
      options: {
        debug: true,
        autoUpload: false,
        request: {
          endpoint: agent.FileUploader.uploadbeneficiary(),
        },
        cors: {
          expected: true,
          sendCredentials: true,
        },
        // deleteFile: {
        //   enabled: true,
        // },
        validation: {
          acceptFiles: allowedExtensions.map(e => `.${e}`),
          allowedExtensions,
          sizeLimit: maxFileSize,
          itemLimit: maxFileNumber,
        },
        chunking: {
          enabled: false,
          partSize: 5242880, // 5mb
          concurrent: {
            enabled: true,
          },
          success: {
          },
        },
        callbacks: {
          // onSubmit: this.uploaderSubmit,
          // onSubmitted: this.uploaderSubmitted,
          // onComplete: this._handleFormSubmit,
          onComplete: this._handleUploadComplete,
          onError: this._handleUploadError,
          // onStatusChange: this.uploaderStatusChange,
          // onProgress: this.uploaderProgress,
          // onUploadChunk: this.uploadChunk,
          // onUploadChunkSuccess: this.uploadChunkSuccess,
          // onUpload: this.startUpload,
          onAllComplete: this._handleAllUploadComplete,
          // onCancel: this.onCancel,
          // onDelete: this.onDelete,
        },
      },
    })
  }

  canSubmit = () => {
    return (this.state.submittedFiles.length > 0)
  }

  handleOpenDialog = (id) => {
    setTimeout(() => { this.setState({ selectedMenuAction: id }) }, 500)
    if (id === constants.BENEFICIARY.LOCK) {
      this.setState({ showLockDialog: true })
    } else if (id === constants.BENEFICIARY.UNLOCK) {
      this.setState({ showUnlockDialog: true })
    } else {
      this.setState({ showUploadDialog: true })
    }
  }

  handleCloseDialog = () => {
    if (this.state.selectedMenuAction === constants.BENEFICIARY.LOCK) {
      this.setState({ showLockDialog: false })
    } else if (this.state.selectedMenuAction === constants.BENEFICIARY.UNLOCK) {
      this.setState({ showUnlockDialog: false })
    } else {
      this.setState({ showUploadDialog: false })
    }
  }

  handleSubmitDialog = (isLocked) => {
    const { selectedMenuAction, currentFy } = this.state
    const { currentUser, lockBeneficiary } = this.props
    const employeeId = currentUser.EmployeeId
    lockBeneficiary(employeeId, isLocked)

    if (selectedMenuAction === constants.BENEFICIARY.LOCK) {
      this.setState({ showLockDialog: false })
    } else if (selectedMenuAction === constants.BENEFICIARY.UNLOCK) {
      this.setState({ showUnlockDialog: false })
    }
  }

  handleSubmitUploadDialog = () => {
    this.setState({ showUploadDialog: false })
    this._handleSubmit()
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      beneficiaryUpload,
    } = this.props

    const unlockBeneficiary = {
      actions: [
        { label: 'CANCEL', onClick: this.handleCloseDialog },
        { label: 'UNLOCK', onClick: () => this.handleSubmitDialog(constants.BENEFICIARY.UNLOCK) },
      ],
      title: 'Unlock Beneficiary?',
      active: this.state.showUnlockDialog,
      onClose: this.handleCloseDialog,
    }

    const lockBeneficiary = {
      actions: [
        { label: 'CANCEL', onClick: this.handleCloseDialog },
        { label: 'LOCK', onClick: () => this.handleSubmitDialog(constants.BENEFICIARY.LOCK) },
      ],
      title: 'Lock Beneficiary?',
      active: this.state.showLockDialog,
      onClose: this.handleCloseDialog,
    }

    const uploadBeneficiary = {
      actions: [
        { label: 'CANCEL', onClick: this.handleCloseDialog },
        { label: 'SUBMIT', onClick: () => this.handleSubmitUploadDialog() },
      ],
      title: 'Upload beneficiary data?',
      active: this.state.showUploadDialog,
      onClose: this.handleCloseDialog,
    }

    const pendingBeneficiary =
      beneficiaryUpload.beneficiaryUploaded.filter(ppr => (String(ppr.status) === constants.BENEFICIARY.UPLOAD_STATUS.PENDING || String(ppr.status) === constants.BENEFICIARY.UPLOAD_STATUS.INPROGRESS))

    // eslint-disable-next-line dot-notation
    // const form = this.props.forms['beneficiaryUpload']
    if (beneficiaryUpload.isFetching) {
      return (<Loading pageLoading />)
    }

    return (
      <div className={styles.content}>
        <Alert showCloseButton={false} type="info">
        Upload records for the current financial year. Click the UPLOAD button to proceed. Column titles are <b>case-sensitive</b>; ensure they match the template exactly. <br /><b>Note that existing beneficiary records for the same FY will be overwritten</b>.
        </Alert><br />
        <section className={styles.section}>
          <div>
            <Heading noTopPadding>Beneficiary is currently {(beneficiaryUpload.beneficiaryLocked === constants.BENEFICIARY.UNLOCK ? 'unlocked' : 'locked')}</Heading>
            <Card>
              <div className={classnames(styles.buttonContainer, styles.flexDirection)}>
                { beneficiaryUpload.beneficiaryLocked === constants.BENEFICIARY.UNLOCK &&
                <div className={styles.buttonElement1}>
                  <Button
                    className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)}
                    onClick={() => this.handleOpenDialog(constants.BENEFICIARY.LOCK)}
                    type="flat"
                  >
                    Lock Beneficiary
                  </Button>
                </div> }
                { beneficiaryUpload.beneficiaryLocked === constants.BENEFICIARY.LOCK &&
                <div className={styles.buttonElement1}>
                  <Button
                    className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)}
                    onClick={() => this.handleOpenDialog(constants.BENEFICIARY.UNLOCK)}
                    type="flat"
                  >
                  Unlock Beneficiary
                </Button>
                </div> }
              </div>
            </Card>
            <Dialog {...unlockBeneficiary}>Open beneficiary for update</Dialog>
            <Dialog {...lockBeneficiary}>Lock beneficiary for update</Dialog>
            <Dialog {...uploadBeneficiary}>Upload beneficiary data for FY{this.state.currentFy}, The upload will overwrite any existing beneficiary data for FY{this.state.currentFy}.</Dialog>
          </div>
          {beneficiaryUpload.fetched && beneficiaryUpload.beneficiaryUploaded &&
          <div>
            <BeneficiaryUploadList
              beneficiaryUploadItems={beneficiaryUpload.beneficiaryUploaded.filter(ppr => (String(ppr.status) !== constants.BENEFICIARY.UPLOAD_STATUS.TEMPLATE))}
              header={constants.BENEFICIARY.UPLOAD_STATUS.COMPLETED}
            />
            <BeneficiaryUploadList
              beneficiaryUploadItems={beneficiaryUpload.beneficiaryUploaded.filter(ppr => String(ppr.status) === constants.BENEFICIARY.UPLOAD_STATUS.TEMPLATE)}
              header={`Download ${constants.BENEFICIARY.UPLOAD_STATUS.TEMPLATE}`}
            />
          </div>}
          <div>
            <Heading noTopPadding>Upload beneficiary CSV</Heading>
            <Card>
              {pendingBeneficiary.length > 0 &&
                <div className={styles.uploadSection}>
                  <Alert showCloseButton={false} type="info">
                Beneficiary upload in progress, please check back later...
                </Alert>
                </div>
              }
              { pendingBeneficiary.length === 0 &&
              <div className={styles.uploadSection}>
                <Alert showCloseButton={false} type="info">
                Ensure filenames only use numbers, letters and underscores.
                </Alert>
                <FileUploader
                  allowedExtensions={['csv']}
                  handleDeleteExistingFile={file => console.log('### delete', file)}
                  handleSelectedFile={() => console.log('### selected ###')} // 1 MB = 1000 * 1000 * 1024 bytes
                  labelWidth={20}
                  maxFileSize={constants.BENEFICIARY.UPLOAD_MAX_FILESIZE}
                  multiple={false}
                  setFileUploaderResponse={this.setFileUploaderResponse}
                  setSubmittedFiles={this.setSubmittedFiles}
                  uploadDescText="CSV only, max 20mb."
                  // disabled={fileUploaderDisabled}
                  uploadTitle="Add files here"
                  uploader={this.state.uploader}
                />
                <div className={styles.footer}>
                  <SubmitButton
                    isLarge
                    complete={this.state.isComplete}
                    completeText={completeText} // Add validation rules
                    disabled={!this.canSubmit()}
                    // onClick={() => this._handleSubmit()}
                    onClick={() => this.handleOpenDialog()}
                    submitting={this.state.isPosting}
                    submittingText={submittingText}
                  >
                    {ctaText}
                  </SubmitButton>
                </div>
              </div>
              }
            </Card>
          </div>
        </section>
      </div>
    )
  }
}

export default BeneficiaryUploadView



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/BeneficiaryUpload.js